import * as yup from 'yup';
import { IUser } from '../../../common';
import { NursingTaskType, TaskDocumentationState, values } from '../../../enums';
import {
  CreateNursingReportFormSchema,
  INursingReportForm,
} from '../nursing-report/INursingReportForm';

export const NursingTaskDocumentationSchema = yup.object({
  type: yup.mixed<NursingTaskType>().oneOf(values(NursingTaskType)).required(),
  state: yup.mixed<TaskDocumentationState>().oneOf(values(TaskDocumentationState)).required(),
  dueDate: yup.date().required(),
});

export const CreateNursingTaskDocumentationSchema = yup
  .object({
    nursingReport: CreateNursingReportFormSchema.notRequired().default(undefined),
    // TODO: create new Task or require existing ID
    // nursingTask: CreateNursingTaskSchema,
  })
  .concat(NursingTaskDocumentationSchema);

export const UpdateNursingTaskDocumentationSchema = yup.object({
  id: yup.string().required(),
  state: yup.mixed<TaskDocumentationState>().oneOf(values(TaskDocumentationState)).required(),
  nursingReport: CreateNursingReportFormSchema.notRequired()
    .default(undefined)
    .when('state', {
      is: (v: TaskDocumentationState) =>
        [
          TaskDocumentationState.DEVIATION,
          TaskDocumentationState.POSTPONED,
          TaskDocumentationState.POSTPONEDSCHEDULED,
        ].includes(v),
      then: CreateNursingReportFormSchema.required(
        `A new NursingReport is required for state POSTPONED or DEVIATION`,
      ),
      otherwise: CreateNursingReportFormSchema.notRequired().default(undefined),
    }),
});

// Documentation object that can be connected to a specific (active) task giving information about task completion date & time and the outcome / state of the task
export interface INursingTaskDocumentation {
  /**
   * Type of the Task (i.e. what kind of task has to be fulfilled for the resident)
   */
  type: NursingTaskType;
  /**
   * The User that fulfilled the Task.
   */
  documentedBy?: IUser;
  documentedById?: string;
  /**
   * The Timestamp where the Task has been completed.
   */
  documentedAt?: Date;
  /**
   * The current state of the Task
   */
  state: TaskDocumentationState;
  /**
   * The Tasks due date, at which the Task has to be completed at latest.
   */
  dueDate: Date;
  /**
   * The Nursing-Report that has to be created if the Task has failed or deviated.
   */
  nursingReportId?: string;
  nursingReport?: INursingReportForm;
  /**
   * The Nursing-Task this Documentation belongs to
   */
  nursingTaskId: string;
}
